import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest, patchRequest } from "../../axios";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import { ErrorNotificationMsg } from "../../utils/Notifications";

import {
  DownloadOutlined,
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import moment from "moment";

const { Option } = Select;
const DriverReport = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const colors = useMemo(() => ["#737373"], []);
  // const colors = ["#737373"];
  const [driverForm] = Form.useForm();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [driverList, setDriverList] = useState([]);
  const formRef = useRef();
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const intialFilter = {
    state: "",
    zone_id: [],
    suburb_id: [],
    driver_id: "",
    status: "",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);

  useEffect(() => {
    const getEmployeeList = async () => {
      setLoading(true);

      const queryParamsObject = {
        ...state,
        start_date: startDate || null,
        end_date: endDate || null,
        state: stateFilter?.state || null,
        driver_id: stateFilter?.driver_id || null,
        status: stateFilter?.status || null,
        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      const payload = {
        zone_id: stateFilter?.zone_id || [],
        suburb_id: stateFilter?.suburb_id || [],
      };
      const queryParamsplusfield = `${queryParams}&fields=${"id,hawb,customer_code,customer_name,postcode_name,customer_address,customer_phone,company_name,status,zone_name,suburb_name,state_name,country_name,created_at,package_failed_delivery_status,assigned_to_pickup_driver,assigned_to,parcel_no,customer_zone"}`;
      try {
        const apiResponse = await patchRequest(
          // `return-driver-report/driver-report-filter/?${queryParams}`,
          `return-driver-report/driver-delivery-report/?${queryParamsplusfield}`,
          payload
        );

        if (apiResponse.data.success) {
          setEmployeeList(apiResponse.data.data);
          settotalCount(apiResponse.data.count);
        }
      } catch (error) {
        ErrorNotificationMsg(t("Error fetching employee list"));
      } finally {
        setLoading(false);
      }
    };

    getEmployeeList();
  }, [state, t]);
  // }, [state, t]);

  const [checkedList, setCheckedList] = useState([
    "parcel_no",
    "hawb",
    "customer_name",
    "customer_address",
    "status",
    "suburb",
    "postcode",
    // "driver__name",
    "state",
    "zone",
    // "driver__name",
    // "driver__delivery_charge",
    "created_at",
    "assigned_to",
    "name",
  ]);

  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const updatedColumns = [
      // Define columns here
      {
        title: "HAWB",
        dataIndex: "hawb",
        key: "hawb",
        sorter: true,
        width: 100,
      },
      {
        title: "Package No.",
        dataIndex: "parcel_no",
        key: "parcel_no",
        sorter: true,
        width: 100,
      },

      {
        title: "Schedule Date",
        dataIndex: "created_at",
        key: "created_at",
        sorter: true,
        width: 100,
        render: (text) => (
          // <Tooltip title={text}>
          <div className="text-ellipsis">
            {text ? moment(text, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY") : "-"}
          </div>
          // </Tooltip>
        ),
      },

      //   {
      //     title: "Driver",
      //     dataIndex: "assigned_to", // Adjust dataIndex to reflect the correct path
      //     key: "name",
      //     render: (assigned_to) => assigned_to ? assigned_to.name : 'N/A', // Render the name or a fallback if not available
      //     sorter: true,
      //     width: 100,
      // },
      {
        title: "Driver",
        dataIndex: "assigned_to",
        key: "name",
        sorter: true,
        width: 100,
        render: (assigned_to) => {
          // Check if assigned_to is an object or "unassigned"
          if (typeof assigned_to === "object" && assigned_to !== null) {
            return assigned_to.name; // Render driver's name if it's an object
          }
          if (assigned_to === "unassigned") {
            return "Unassigned"; // Render 'Unassigned' if it's the string 'unassigned'
          }
          return "N/A"; // Fallback in case assigned_to is null or undefined
        },
      },

      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: true,
        width: 100,
      },
      // {
      //   title: "Driver",
      //   dataIndex: "driver_name",
      //   key: "driver__name",
      //   sorter: true,
      //   width: 100,
      // },
      // {
      //   title: "Delivery Charge",
      //   dataIndex: "driver_delivery_charge",
      //   key: "driver__delivery_charge",
      //   sorter: true,
      //   width: 100,
      // },
      {
        title: "Customer Name",
        dataIndex: "customer_name",
        key: "customer_name",
        sorter: true,
        width: 100,
      },
      {
        title: "Address",
        dataIndex: "customer_address",
        key: "customer_address",
        sorter: true,
        width: 150,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Suburb",
        dataIndex: "suburb_name",
        key: "suburb",
        sorter: true,
        width: 100,
      },
      {
        title: "Postal Code",
        dataIndex: "postcode_name",
        key: "postcode",
        sorter: true,
        width: 100,
      },
      {
        title: "State",
        dataIndex: "state_name",
        key: "state",
        sorter: true,
        width: 100,
      },
      {
        title: "Run",
        dataIndex: "zone_name",
        key: "zone",
        sorter: true,
        width: 100,
      },
    ].filter((column) => checkedList.includes(column.key));
    setColumns(updatedColumns);
  }, [checkedList, driverList, t, colors]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="parcel_no">Package No.</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="hawb">HAWB</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="created_at">Schedule Date</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="assigned_to">Driver</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            {/* <Col span={12}>
              <Checkbox value="driver__name" >Driver </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="driver__delivery_charge">Delivery Charge</Checkbox>
            </Col> */}
            <Col span={12}>
              <Checkbox value="customer_name"> Customer Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="customer_address"> Address</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="suburb">Suburb</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="postcode">Postal Code</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="state">State</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="zone">Run</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    const getDeliveryStatus = async () => {
      try {
        const response = await getRequest("employee/drivers-list/");
        const { data } = response.data;

        setDriverList(data);
        formRef.current.setFieldsValue(response.data.data);
      } catch (error) {
        // setapiLoading(false);
      }
    };
    getDeliveryStatus();
  }, [state, t]);

  const handleDriverFilter = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      driver_id: value,
    }));
  };

  const handleDeliveryStatus = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      status: value,
    }));
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      driverForm.resetFields(); // Reset the driver form fields
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "customer_name" && sortOrder === "ascend") {
      sortingEnumKey = "customer_name";
    }
    if (sortField === "customer_name" && sortOrder === "descend") {
      sortingEnumKey = "-customer_name";
    }

    if (sortField === "hawb" && sortOrder === "ascend") {
      sortingEnumKey = "hawb";
    }
    if (sortField === "hawb" && sortOrder === "descend") {
      sortingEnumKey = "-hawb";
    }
    if (sortField === "customer_address" && sortOrder === "ascend") {
      sortingEnumKey = "customer_address";
    }
    if (sortField === "customer_address" && sortOrder === "descend") {
      sortingEnumKey = "-customer_address";
    }

    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb__area";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb__area";
    }

    if (sortField === "postcode" && sortOrder === "ascend") {
      sortingEnumKey = "postcode__pincode";
    }
    if (sortField === "postcode" && sortOrder === "descend") {
      sortingEnumKey = "-postcode__pincode";
    }

    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "zone" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "driver__name" && sortOrder === "ascend") {
      sortingEnumKey = "driver__name";
    }
    if (sortField === "driver__name" && sortOrder === "descend") {
      sortingEnumKey = "-driver__name";
    }
    if (sortField === "driver__delivery_charge" && sortOrder === "ascend") {
      sortingEnumKey = "driver__delivery_charge";
    }
    if (sortField === "driver__delivery_charge" && sortOrder === "descend") {
      sortingEnumKey = "-driver__delivery_charge";
    }
    if (sortField === "parcel_no" && sortOrder === "ascend") {
      sortingEnumKey = "parcel_no";
    }
    if (sortField === "parcel_no" && sortOrder === "descend") {
      sortingEnumKey = "-parcel_no";
    }
    if (sortField === "created_at" && sortOrder === "ascend") {
      sortingEnumKey = "created_at";
    }
    if (sortField === "created_at" && sortOrder === "descend") {
      sortingEnumKey = "-created_at";
    }
    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "assign_package__driver__name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-assign_package__driver__name";
    }

    return sortingEnumKey;
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const handleApplyFilter = async () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };
  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setEndDate(formattedDate);
  };

  const minEndDate = startDate
    ? moment(startDate, "DD-MM-YYYY").startOf("day")
    : null;

  const handleResetFilter = () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);

    form.setFieldsValue({ search: "" });
    setStartDate(null);

    formRef.current.setFieldsValue({
      state: undefined,
      zone: undefined,
      suburb: undefined,
      start_date: undefined,
      end_date: undefined,
      status: undefined,
      driver_id: undefined,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRow(selectedRowKeys);

      if (selectedRowKeys.length === 0) {
        driverForm.resetFields();
      }
    },
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow?.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);

      if (updatedSelectedRowKeys?.length === 0) {
        driverForm.resetFields();
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow?.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);

      if (updatedSelectedRowKeys?.length === 0) {
        driverForm.resetFields();
      }
    },
    selectedRowKeys: selectedRow,
  };

  // const downloadCSV = async () => {
  //   // const endpoint = `return-driver-report/driver-report-excel-download/`;
  //   const endpoint = `return-driver-report/driver-report-excel-download/`;
  //   const fileType = "csv";

  //   try {
  //     await getRequest(endpoint).then((response) => {
  //       const blob = new Blob([response.data], {
  //         type: "text/csv",
  //       });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = `LateReturnReport${+new Date()}.${fileType}`;
  //       link.click();
  //     });
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       console.error("File not found or endpoint is incorrect.");
  //     } else {
  //       console.error("Error downloading the file:", error);
  //     }
  //   }
  // };

  const downloadCSV = async () => {
    setBtnLoading(true);
    const endpoint = `return-driver-report/driver-report-excel-download/`;
    const fileType = "csv";

    // Construct query parameters
    const queryParamsObject = {
      // ...state,
      start_date: startDate || null,
      end_date: endDate || null,
      state: stateFilter?.state || null,
      driver_id: stateFilter?.driver_id || null,
      status: stateFilter?.status || null,
      // page: state.page,
      ordering: state.ordering,
      // pagesize: state.pagesize,
      search: state.search,
      total: state.total,
    };

    const queryParams = new URLSearchParams(
      Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    // Create payload
    const payload = {
      zone_id: stateFilter?.zone_id || [],
      suburb_id: stateFilter?.suburb_id || [],
    };

    try {
      // Use patchRequest instead of getRequest
      const response = await patchRequest(
        `${endpoint}?${queryParams}`,
        payload
      );

      // Process the downloaded file as CSV
      const blob = new Blob([response.data], {
        type: "text/csv",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `DriverReport${+new Date()}.${fileType}`;
      link.click();
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        setBtnLoading(false);
      } else {
        console.error("Error downloading the file:", error);
        setBtnLoading(false);
      }
    }
  };

  return (
    <>
    <div className="mainwrapper">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & Manage The List Of Packages Within The Organization.
                </span>
              }
            > */}
            <h3>{t("Driver Report")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Driver Report")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                overlayClassName="customdropdwn"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="filterrow packagefilter">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef} layout="vertical">
                <Space wrap
                      size={[16, 10]}>
                 
                    <Form.Item
                      name="start_date"
                      label={t("pl_min_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_start_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleStartDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("statr_date")}
                      />
                    </Form.Item>
                  
                    <Form.Item
                      name="end_date"
                      label={t("pl_max_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_end_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleEndDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("end_date")}
                        disabled={!startDate}
                        disabledDate={(current) =>
                          current && (minEndDate ? current < minEndDate : false)
                        }
                      />
                    </Form.Item>
                
                    <Form.Item name="driver_id" label={t("pl_driver")}>
                      <Select
                        placeholder={t("pl_assign_driver")}
                        showArrow
                        showSearch
                        style={{ width: "170px" }}
                        name="driver_id"
                        optionFilterProp="children"
                        onChange={(value) => handleDriverFilter(value)}
                      >
                        {driverList?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                 
                    <Form.Item
                      name="status"
                      label={t("delivery_status")}
                      value={state?.status}
                    >
                      <Select
                        showArrow
                        placeholder={t("pl_delivery_status")}
                        onChange={(value) => handleDeliveryStatus(value)}
                      >
                        {/* <Option key="Not Scanned" value="Not Scanned">
                          Not Scanned
                        </Option>
                        <Option key="Received in Depo" value="Received in Depo">
                          Received in Depo
                        </Option>
                        <Option key="Loaded" value="Loaded">
                          Loaded
                        </Option> */}
                        <Option key="Delivered" value="Delivered">
                          Delivered
                        </Option>
                        <Option key="Failed Delivery" value="Failed Delivery">
                          Failed Delivery
                        </Option>
                        {/* <Option
                          key="RTS- Return to Sender"
                          value="RTS- Return to Sender"
                        >
                          RTS- Return to Sender
                        </Option>
                        <Option
                          key="RD- Return to depo"
                          value="RD- Return to depo"
                        >
                          RD- Return to depo
                        </Option> */}
                      </Select>
                    </Form.Item>
                
                </Space>
              </Form>
            </div>
            <div className="btnscol btncolpack">
              <Space className="btnpack">
                <>
                  {/* <Tooltip title="Apply Filter"> */}
                  <Button
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Apply"
                    // label="Apply"
                    onClick={handleApplyFilter}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                      Filter
                    </span>
                  </Button>
                  {/* </Tooltip> */}
                  {startDate ||
                  endDate ||
                  stateFilter?.status ||
                  stateFilter?.driver_id ? (
                    // <Tooltip title="Reset Filter">
                    <Button
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      // label="Reset"
                      onClick={handleResetFilter}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <UndoOutlined
                          style={{ fontSize: "16px", color: "#fff" }}
                        />{" "}
                        Reset
                      </span>
                    </Button>
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </>
                {/* <Tooltip title="Download CSV"> */}
                <Button
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="DownloadPDF"
                  // label="Download CSV"
                  onClick={downloadCSV}
                  loading={btnLoading}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: "16px" }} /> Download
                    CSV
                  </span>
                </Button>
                {/* </Tooltip> */}
              </Space>
            </div>
          </div>
<div className="tablewrp">
          <Table
            // rowSelection={rowSelection}
            scroll={{ x: 1000 }}
            rowKey={(record) => record.id}
            columns={columns.filter((col) => !col.hidden)}
            dataSource={employeeList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
      </div>
    </>
  );
};
export default DriverReport;
